import { Link } from 'react-router-dom';
import Header from '../components/layout/Header.jsx';
import Footer from '../components/layout/Footer.jsx';

export default function NotFoundPage() {
  return (
    <>
      <Header variant="bare" />
      <div className="page-wrap">
        <section className="legal-hero">
          <div className="legal-hero-inner">
            <span className="legal-eyebrow">Página no encontrada</span>
            <h1>404</h1>
            <p>La página que buscas no existe o ha sido movida.</p>
            <p style={{ marginTop: 24 }}>
              <Link to="/" className="legal-action">
                Volver a la página principal
              </Link>
            </p>
          </div>
        </section>
      </div>
      <Footer variant="bare" />
    </>
  );
}
